<template>
  <Loading v-if="isLoading" variant="main" />
  <SiteImportantKeywordGA4
    v-else-if="isViewGA4"
    :id="id"
    :keyword="keyword"
    :project="project"
    :status="status"
  />
  <SiteImportantKeywordUA
    v-else
    :id="id"
    :keyword="keyword"
    :project="project"
    :status="status"
    :isGaTypeError="isGaTypeError"
  />
</template>

<script>
import Loading from '@/components/Loading';
import SiteImportantKeywordGA4 from '@/views/siteImportantKeyword/SiteImportantKeywordGA4';
import SiteImportantKeywordUA from '@/views/siteImportantKeyword/SiteImportantKeywordUA';

export default {
  props: {
    canViewGA4: {
      type: Boolean,
      required: true
    },
    canViewUA: {
      type: Boolean,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    keyword: {
      type: String,
      required: false
    },
    project: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: false
    }
  },
  components: {
    Loading,
    SiteImportantKeywordGA4,
    SiteImportantKeywordUA
  },
  data() {
    return {
      gaType: 'ua',
      isGaTypeError: false,
      isLoading: true
    };
  },
  computed: {
    isViewGA4() {
      return this.gaType === 'ga4';
    }
  },
  async created() {
    try {
      this.gaType = await this.getGaType();
    } catch (error) {
      this.isGaTypeError = true;
    }
    this.isLoading = false;
  },
  methods: {
    async getGaType() {
      if (this.canViewGA4 && this.canViewUA) {
        try {
          const gaVersion = await this.$store.dispatch('project/getGaVersion');
          const gaType = gaVersion.siteImportantKeyword;
          return gaType === 'ua' ? 'ua' : 'ga4';
        } catch (error) {
          throw error;
        }
      } else if (this.canViewGA4) {
        return 'ga4';
      } else {
        return 'ua';
      }
    }
  }
};
</script>
